/*
 * Jira Ticket:
 * Created Date: Mon, 4th Nov 2019, 11:35:21 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2019 The Distance
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Toolbar } from '@material-ui/core';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';

const CursorPagination = props => {
  const { page, cursors, setPage } = props;

  useEffect(() => {
    // This is to prevent hard page reloads from getting us into
    // an invalid state
    const pageCursorIndex = page - 1;
    if (
      pageCursorIndex < 0 ||
      pageCursorIndex >= cursors.length ||
      (cursors[pageCursorIndex] === null && pageCursorIndex !== 0)
    ) {
      setPage(1);
    }
  }, [page, cursors, setPage]);

  return (
    <Toolbar>
      <Button
        key="prev"
        icon={<ChevronLeft />}
        onClick={() => setPage(page - 1)}
        disabled={page === 1}
      >
        Prev
      </Button>
      <Button
        key="next"
        icon={<ChevronRight />}
        onClick={() => setPage(page + 1)}
        disabled={!cursors[page] || cursors[page] === null}
      >
        Next
      </Button>
    </Toolbar>
  );
};

CursorPagination.propTypes = {
  cursors: PropTypes.array,
  page: PropTypes.number,
  perPage: PropTypes.number,
  total: PropTypes.number,
  setPage: PropTypes.func,
};

export default CursorPagination;
